import { UseFormRegister, FieldValues, DeepMap, FieldError } from 'react-hook-form';
import EditButton from '../EditButton';
import generateErrorMarkup from '../generateErrorMarkup';

type Props = {
  name: string;
  label: string;
  disclaimer?: React.ReactElement;
  // Optional default value (will revert to formData[name] if none)
  defaultValue?: string;
  showEditBtn: boolean;
  editable: boolean;
  validationObj?: any; // TODO: add types
  hidden?: boolean;

  register: UseFormRegister<FieldValues>;
  errors: DeepMap<FieldValues, FieldError>;
  formData: any;
  returnToStep?: (fieldName: string) => void;
}

/**
 * A DateInput component
 * @param props
 */
let DateInput = (props: Props) => {
  if (props.hidden) return null;

  // TODO: react-hook-form probably has a better way of passing refs around
  // but this seems to work for now...
  const { register, errors } = props;

  const clickEditBtn = (e: React.MouseEvent) => {
    // Only has one if added for reviewMode
    if (props.returnToStep) props.returnToStep(props.name);
  };

  const defaultValue = props.defaultValue ?? props.formData[props.name] ?? '';
  const required = props.validationObj?.required;

  const elem =
    <div className="DateInput">
      <label>
        <div className="DateInput__Wrapper">
          <span className="DateInput__heading">
            {`${props.label}`}{required? '*' : ' (Optional)'}
          </span>

          <input type="date" {...register(props.name, {
              ...props.validationObj,
              // valueAsDate: true,
            })}
            defaultValue={defaultValue}
            pattern="\d{4}-\d{2}-\d{2}"
            max={props.validationObj?.max}
            className={errors[props.name] ? 'parsley-error' : undefined}
            aria-describedby={errors[props.name] ? `${props.name}-errors` : undefined}
            // NOTE: getValues doesn't return the value if the input is disabled!
            disabled={!props.editable}
          />
        </div>

        {props.disclaimer ?
          <div className="Field__Disclaimer">
            {props.disclaimer}
          </div>
        : null
        }

      { props.showEditBtn ? <EditButton onClick={clickEditBtn} /> : null }
      </label>
      { generateErrorMarkup(errors, props.name) }
    </div>;

  return (
    <>
      {elem}
    </>
  );
};

export default DateInput;
